import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { REVIEWS } from "@/data";

export const Reviews = () => {
  return (
    <section data-testid="reviews-section" className="relative bg-[var(--bg-2)] py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex items-center gap-3 mb-14">
          <span className="flex items-center gap-1">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={16} className="fill-[var(--blue)] text-[var(--blue)]" />
            ))}
          </span>
          <span className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-[var(--txt-1)]">
            Ils nous font confiance à Marseille
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={r.name}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="rounded-md border border-white/10 bg-[var(--bg-0)] p-8 flex flex-col"
            >
              <Quote size={28} className="text-[var(--blue)] mb-6" />
              <p className="text-lg leading-relaxed text-white italic flex-1">“{r.text}”</p>
              <div className="mt-8 border-t border-white/10 pt-4">
                <p className="font-mono2 text-xs uppercase tracking-[0.15em] text-white">{r.name}</p>
                <p className="font-mono2 text-[11px] uppercase tracking-[0.15em] text-[var(--txt-2)] mt-1">{r.role}</p>
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
